import {
  getFileTextMessageFilenameAndURL,
  textMessageContainsFile,
} from "../../utils";
import { FileMessageDisplay } from "../FileMessageDisplay";

import type { MessageEnvelope } from "@pubnub/react-chat-components";

interface Props {
  message: MessageEnvelope;
  userIsAuthor: boolean;
}
export function TextMessageFileDisplay(props: Props) {
  const { message, userIsAuthor } = props;
  if (!textMessageContainsFile(message)) {
    return null;
  }

  const file = getFileTextMessageFilenameAndURL(message);
  return (
    <FileMessageDisplay
      userIsAuthor={userIsAuthor}
      fileName={file.fileName}
      fileURL={file.fileUrl}
    />
  );
}
